import styled from 'styled-components'

import { StyledButton } from 'components'
import { COLOR } from 'styles/constants'

export const FontWrapper = styled.div<{ margin?: string }>`
  font-family: 'Poppins';

  p,
  span,
  label,
  button,
  input {
    font-family: 'Poppins';
  }

  ${(props) => props.margin && `margin: ${props.margin};`}
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  // width: 1280px;
  width: 920px;
  align-items: center;

  @media (max-width: 991px) {
    width: 100%;
  }
`
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 920px;
  min-width: 590px;

  @media (max-width: 991px) {
    flex-direction: column;
    width: 100%;
    min-width: unset;
    justify-content: center;
    align-items: center;
  }
`

export const Panel = styled.div<{ width?: string; margin?: string; zIndex?: string }>`
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.margin && `margin: ${props.margin};`}
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
 
  display: flex;
  flex-direction: column;
  max-width: 710px;

  @media (max-width: 991px) {
    width: 100%;
    margin: 0;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: 991px) {
    padding: 0 20px;
  }
`

export const AgentProfileDesktopWrapper = styled.div`
  display: block;
  @media (max-width: 991px) {
    display: none;
  }
`

export const AgentProfileMobileWrapper = styled.div`
  display: none;
  padding: 0 20px;
  margin: 20px 0 30px 0;
  @media (max-width: 991px) {
    display: block;
    width: 100%;
  }
`

export const StyledDescriptionText = styled.p`
  word-wrap: break-word;
  size: 16px;
  line-height: 24px;
  white-space: pre-line;
`

export const CTAButton = styled(StyledButton)`
  height: 40px;
  box-size: border-box;
  padding: 0 1.5em;
  border-radius: 20px;
  ${({ disabled }) => !disabled && `border: 1px solid ${COLOR.GRAY_SCALE_30};`}
  color: ${({ disabled }) => (disabled ? COLOR.GREY_LV3 : COLOR.GREY_LV1)};
  border: ${({ disabled }) => disabled && 'none'};
  background-color: ${({ disabled }) => (disabled ? COLOR.GRAY_SCALE_15 : COLOR.WHITE)};
  font-size: 16px;
  line-height: 28px;
  transition: all 0.3s ease-in-out;
  &:hover {
    ${({ disabled }) => !disabled && `background-color: ${COLOR.GRAY_SCALE_15};`}
  }
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 20px;
  }
`
